<template>
  <div>
    <v-card>
      <v-card-title>
        <span class="headline" style="text-transform: uppercase;">{{ formaction }} Portal</span>
      </v-card-title>

      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs4>
              <v-text-field
                v-model="Form.portalName"
                v-validate="'required|max:25'"
                data-vv-rules="required"
                data-vv-scope="portalForm"
                :error-messages="errors.collect('portalForm.portalName')"
                hide-details
                :counter="25"
                label="Portal Name*"
                name="portalName"
              />
            </v-flex>
            <v-flex xs4>
              <v-text-field
                v-model="Form.domainURL"
                v-validate="'required|max:50'"
                data-vv-rules="required"
                data-vv-scope="portalForm"
                :error-messages="errors.collect('portalForm.domainURL')"
                hide-details
                :counter="50"
                label="Domain URL*"
                name="domainURL"
              />
            </v-flex>
            <v-flex xs4>
              <v-text-field 
                v-model="Form.primary"
                v-validate="'required'"                
                data-vv-rules="required"
                data-vv-scope="portalForm"
                :error-messages="errors.collect('portalForm.primary')"
                hide-details
                label="Primary*"
                name="primary"
                />
              <v-icon class="icon" :style="{ color: Form.primary }">color_lens</v-icon>
            </v-flex>
            <v-flex xs4>
              <v-text-field 
                v-model="Form.secondary"
                v-validate="'required'"                
                data-vv-rules="required"
                data-vv-scope="portalForm"
                :error-messages="errors.collect('portalForm.secondary')"
                hide-details 
                label="Secondary*"
                name="secondary"
                />
              <v-icon class="icon" :style="{ color: Form.secondary }">color_lens</v-icon>
            </v-flex>
            <v-flex xs4>
              <v-text-field 
                v-model="Form.error" 
                v-validate="'required'"                
                data-vv-rules="required"
                data-vv-scope="portalForm"
                :error-messages="errors.collect('portalForm.error')"
                hide-details
                label="Error*"
                name="error"
                />
              <v-icon class="icon" :style="{ color: Form.error }">color_lens</v-icon>
            </v-flex>
            <v-flex xs4>
              <v-text-field 
                v-model="Form.info" 
                v-validate="'required'"                
                data-vv-rules="required"
                data-vv-scope="portalForm"
                :error-messages="errors.collect('portalForm.info')"
                hide-details
                label="Info*"
                name="info"
                />
              <v-icon class="icon" :style="{ color: Form.info }">color_lens</v-icon>
            </v-flex>
            <v-flex xs4>
              <v-text-field
                v-model="Form.success" 
                v-validate="'required'"                
                data-vv-rules="required"
                data-vv-scope="portalForm"
                :error-messages="errors.collect('portalForm.success')"
                hide-details
                label="Success*"
                name="success"
                />
              <v-icon class="icon" :style="{ color: Form.success }">color_lens</v-icon>
            </v-flex>
            <v-flex xs4>
              <v-text-field 
                v-model="Form.warning" 
                v-validate="'required'"                
                data-vv-rules="required"
                data-vv-scope="portalForm"
                :error-messages="errors.collect('portalForm.warning')"
                hide-details
                label="Warning*"
                name="warning"
                />
              <v-icon class="icon" :style="{ color: Form.warning }">color_lens</v-icon>
            </v-flex>
            <v-flex xs4>
              <v-text-field 
                v-model="Form.page" 
                v-validate="'required'"                
                data-vv-rules="required"
                data-vv-scope="portalForm"
                :error-messages="errors.collect('portalForm.page')"
                hide-details
                label="Page*"
                name="page"
                />
              <v-icon class="icon" :style="{ color: Form.page }">color_lens</v-icon>
            </v-flex>
            <v-flex xs4>
              <v-text-field 
                v-model="Form.card" 
                v-validate="'required'"                
                data-vv-rules="required"
                data-vv-scope="portalForm"
                :error-messages="errors.collect('portalForm.card')"
                hide-details
                label="Card*"
                name="card"
                />
              <v-icon class="icon" :style="{ color: Form.card }">color_lens</v-icon>
            </v-flex>
            <v-flex xs4>
              <v-text-field 
                v-model="Form.footer" 
                v-validate="'required'"                
                data-vv-rules="required"
                data-vv-scope="portalForm"
                :error-messages="errors.collect('portalForm.footer')"
                hide-details
                label="Footer*"
                name="footer"
                />
              <v-icon class="icon" :style="{ color: Form.footer }">color_lens</v-icon>
            </v-flex>
            <v-flex xs12 class="input-container">
              <span v-if="Form.enabled" style="padding-top: 25px;">Enabled</span>
              <span v-else style="padding-top: 25px;">Disabled</span>
              <v-switch v-model="Form.enabled" style="padding-left: 15px;"></v-switch>
            </v-flex>
          </v-layout>
        </v-container>
        <small>*indicates required field</small>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" flat @click.native="CloseDialog()">Close</v-btn>
        <v-btn color="blue darken-1" flat @click.native="SaveDocument('portalForm')">Save</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
export default {
  props: {
    admin: {
      type: Object,
      default() {
        return {};
      }
    },
    adminportal: {
      type: Object,
      default() {
        return {};
      }
    },
    form: {
      type: Object,
      default() {
        return {};
      }
    },
    formaction: {
      type: String,
      default: ""
    },
    portallookups: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data: () => ({
    Form: {}
  }),
  watch: {
    formaction() {
      if (this.formaction === "create") {
        this.Form = {};
      } else if (this.formaction === "edit") {
        this.Form = this.form;
      }
    }
  },
  methods: {
    CloseDialog() {
      this.$emit("Dialog", false);
    },
    SaveDocument(scope) {
      this.$validator.validateAll(scope).then(valid => {
        if (!valid) {
          // do nothing
        } else {
          //console.log("Save Document + " + this.formaction);
          switch (this.formaction) {
            case "create":
              this.$store.dispatch("Admin/createDocument", [
                this.admin.Collection,
                this.Form,
                "Admin/setDocumentResult"
              ]);
              break;
            case "edit":
              var id = this.Form.id;
              //console.log(JSON.stringify(this.Form, null, 2));
              this.Form = this.$omit(this.Form, [
                "vgt_id",
                "originalIndex",
                "id"
              ]);
              //console.log(JSON.stringify(this.Form, null, 2));
              this.$store.dispatch("Admin/updateDocument", [
                this.admin.Collection,
                id,
                this.Form
              ]);
              break;
            default:
              break;
          }
          this.CloseDialog();
        }
      });
    }
  }
};
</script>

<style>
.input-container {
  vertical-align: middle !important;
  display: flex;
  width: 100%;
  margin-bottom: 15px;
}
.icon {
  padding-top: 20px;
  min-width: 50px;
  text-align: center;
}
</style>